var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "building-detail" }, [
    _c("div", { staticClass: "building-detail__header" }, [
      _c(
        "div",
        {
          staticClass: "building-detail__header--back",
          on: {
            click: function ($event) {
              return _vm.navBack()
            },
          },
        },
        [_vm._v("< " + _vm._s(_vm.$t("back")))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "building-detail__header--btn" }, [
        _vm.isEditing && _vm.tid !== "createTemplate"
          ? _c(
              "button",
              { staticClass: "btn btn--darkblue", on: { click: _vm.cancel } },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditing
          ? _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: { click: _vm.addOneTemplateChip },
              },
              [_vm._v(_vm._s(_vm.$t("action.add")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditing
          ? _c(
              "button",
              { staticClass: "btn btn--orange", on: { click: _vm.save } },
              [_vm._v(_vm._s(_vm.$t("action.save")))]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isEditing && _vm.isEditShow
          ? _c(
              "button",
              { staticClass: "btn btn--orange", on: { click: _vm.edit } },
              [_vm._v(_vm._s(_vm.$t("action.edit")))]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "building-detail__tabs" },
      [
        _c(
          "TabsContainer",
          {
            staticClass: "building-detail__tabs--header",
            attrs: { tabNames: _vm.tabNames, getCurrentTab: _vm.getCurrentTab },
          },
          [
            _c("building-template", {
              ref: "tab-0",
              attrs: { slot: "tab-0", isEditing: _vm.isEditing },
              slot: "tab-0",
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }